// extracted by mini-css-extract-plugin
module.exports = {"contact-label":"contact-module__contact-label___31AzM","contactLabel":"contact-module__contact-label___31AzM","label":"contact-module__label___1pSpQ"};